import { render } from "./Folder.vue?vue&type=template&id=dc0a0090&scoped=true&bindings={}"
import script from "./Folder.vue?vue&type=script&lang=ts"
export * from "./Folder.vue?vue&type=script&lang=ts"

import "./Folder.vue?vue&type=style&index=0&id=dc0a0090&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-dc0a0090"

export default script